import React from 'react';
import {HStack, Input, VStack} from "@chakra-ui/react";
import EntityModalContent from "@/components/entity/EntityModalContent";
import {Button} from "@/components/ui";
import {useForm} from "@/uses/useForm";
import {useLanguage} from "@/contexts/languageContext";
import {Field, FilePreview, LanguageField} from "@/components";

export const NameFiles = ({files, close, onSuccess}) => {

    const { getLangObject, t } = useLanguage();
    /** Form used by naming image modal */
    const {
        formData,
        formFieldErrors,
        handleInputChange,
        handleFormSubmit
    } = useForm(
        files.reduce((acc, file, i) => ({...acc, [i]: getLangObject(file.filename)}), {}),
        files.reduce((acc, file, i) => ({
            ...acc, [i]: {
                custom: {
                    function: (value) => {
                        return Object.values(value).every((value) => value && value.length >= 3)
                    },
                    message: t('errors.pleaseFillFieldAllLanguages')
                },
            }
        }), {}));


    return <EntityModalContent
        title={t('nameImages')}
        close={close}
        Body={<VStack p="1.5rem" overflowY="auto" w="100%">
            {
                files.map((file, i) => {
                    return <Field
                        key={`file-${file.filename}`}
                        p={4}
                    >
                        <HStack w="100%" gap="1rem">
                            <VStack position="relative" overflow="hidden" justify="center" align="center" maxH="20vh" w="40%" h="100%">
                                <FilePreview fileUrl={file.previewUrl || file.url} alt={file.filename} w="100%" h="100%"/>
                            </VStack>
                            <LanguageField
                                flex={1}
                                id={`label-${file.filename}`}
                                errors={formFieldErrors[i]}
                                label={t('wrappers.mandatoryLabel', { value: t('fields.filename') })}
                                renderElement={(lang) => <Input
                                    value={formData[i][lang]}
                                    onChange={(e) => {
                                        handleInputChange(i, {...formData[i], [lang]: e?.target?.value ?? ''})
                                    }}
                                    placeholder={t('wrappers.capitalize', { value: t('fields.filename')} )}
                                />}
                            />
                        </HStack>
                    </Field>
                })
            }
            <HStack>
                <Button
                    variant="primary"
                    mt="auto"
                    height="auto"
                    borderRadius=".5rem"
                    style={{padding: "1rem 1.5rem"}}
                    onClick={() => close()}
                >
                    {t('actions.cancel')}
                </Button>
                <Button
                    variant="primary"
                    mt="auto"
                    height="auto"
                    borderRadius=".5rem"
                    style={{padding: "1rem 1.5rem"}}
                    onClick={() => {
                        handleFormSubmit((data) => ({
                            /** Mock API response */
                            data: {
                                value: files.map((file, i) => ({
                                    url: file.url,
                                    label: data[i]
                                }))
                            }
                        }), (data) => {
                            onSuccess(data);
                            close();
                        })
                    }}
                >
                    {t('actions.validate')}
                </Button>
            </HStack>
        </VStack>}
    />
}

export default NameFiles;
